import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {  useParams } from "react-router-dom";
import Menu from '../../components/Menu';
import Topo from '../../components/Topo';
import Aguarde from '../../components/Aguarde';
import api from '../../services/api';
import Swal from 'sweetalert2'
import moment from 'moment';


function Dividas(props){    
    const { doc } = useParams();
    const [dados, setDados] = useState({});
    const [loading, setLoging] = useState(0);
    const [error, setError] = useState(null);
    const Voltar = (e) => {
        e.preventDefault(0);
        window.location = '../Painel';
        return;
    }

    useEffect( () => {
        setLoging(1);
        async function getDados(){
            try{
                var dados = await api.get('api/dividas/'+doc);
            }catch(e){
                var dados = '';
                setLoging(0);
                setError('Indisponivel no momento.');
            }

            if(dados.data.msg === 'token invalido.'){
                setLoging(0);
                window.location = '../Sair';
                setError('Token invalido, refaça seu login.');
            }else if(dados.data.msg){
               // alert(dados.data.msg);
                Swal.fire(
                    'Atenção!',
                    dados.data.msg,
                    'error'
                  )
                  setLoging(0)
//              window.location = '../Painel';
            }else{
                if(dados.data === '"null"'){
                    
                    setLoging(0);
                    setError('Indisponivel no momento.');
        
                }else{
                    setDados(dados.data);                
                    setLoging(0);
                    setError(null);

                    document.getElementById('box').style.display = 'block';
                }
            }
        }
       getDados();

    }, [doc, setDados]);

    return (<div className="main-content">
        <Menu />
        <div id="page-wrapper">
            <Topo />
            {error !== null && <Aguarde id="loading" titulo="Ocorreu um erro, tente novamente em breve."/>}
            {loading > 0 && <Aguarde id="loading" titulo="Aguarde, carregando..."/>}
            <div id='box'>

    

    {typeof dados.html != 'undefined' ? (<div className="row">
                    <div className="col-md-10 col-md-offset-1">
                        <ul className="nav nav-tabs" role="tablist">
                            <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab" className="tab-result">Resultado</a></li>
                        </ul>
                        <div className="tab-content">
                            <div role="tabpanel" className="tab-pane active" id="home">
                                <div className="table-responsive">
                                      <div
                                        dangerouslySetInnerHTML={{ __html: dados.html }}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
    </div>) : (``)}


</div></div>
<center>
    <br/>
    <button className="btn btn-primary" onClick={Voltar} type="button" name="nova_consulta" id="nova_consulta">Nova consulta</button>
    <br/><br/><br/><br/>
</center>
</div>);
}

export default Dividas;
